var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_486_16866",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_486_16866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33577 19.289H12.0063V17.9549H5.33577V19.289ZM5.33577 16.6208H15.5639V15.2867H5.33577V16.6208ZM5.33577 13.9526H15.5639V12.6185H5.33577V13.9526ZM2.00049 25.7714V10.891C2.00049 10.4417 2.15613 10.0614 2.46743 9.75014C2.77872 9.43885 3.159 9.2832 3.60827 9.2832H17.2914C17.7407 9.2832 18.121 9.43885 18.4323 9.75014C18.7436 10.0614 18.8992 10.4417 18.8992 10.891V21.0165C18.8992 21.4658 18.7436 21.8461 18.4323 22.1573C18.121 22.4686 17.7407 22.6243 17.2914 22.6243H5.14762L2.00049 25.7714ZM4.57977 21.2902H17.2914C17.3598 21.2902 17.4226 21.2617 17.4796 21.2047C17.5366 21.1477 17.5651 21.0849 17.5651 21.0165V10.891C17.5651 10.8226 17.5366 10.7598 17.4796 10.7028C17.4226 10.6458 17.3598 10.6173 17.2914 10.6173H3.60827C3.53985 10.6173 3.47712 10.6458 3.4201 10.7028C3.36308 10.7598 3.33458 10.8226 3.33458 10.891V22.5217L4.57977 21.2902Z",
    fill: "#00AAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.9238,
    y: 2.99973,
    width: 11.559,
    height: 9.08207,
    rx: 0.825642,
    fill: "#00AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5757 10.4305L19.1765 4.65097H20.2333L22.8423 10.4305H21.7194L19.4819 5.22066H19.9113L17.682 10.4305H16.5757ZM17.7729 9.09293L18.0618 8.25077H21.1828L21.4717 9.09293H17.7729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5773 10.4305V4.65097H24.6507V10.4305H23.5773Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.210669d552ee5647ab2783ca4be6ecc8.svg";
export { ForwardRef as ReactComponent };